<template>
	<div class="datepicker-days" >
		<table v-for="(month,$index) in tableData" >
			<thead>
				<tr>
					<th >
						<i v-show="$index==0" @click="min"><</i>
					</th>
					<th colspan="5">{{getNormalMonth(monthIndex+Number($index))}} </th>
					<th >
						<i v-show="$index==1" @click="add">></i>
					</th>
				</tr>
			</thead>
            <thead>
                <tr>
                    <th>日</th>
                    <th>一</th>
                    <th>二</th>
                    <th>三</th>
                    <th>四</th>
                    <th>五</th>
                    <th>六</th>
                </tr>
            </thead>
            <tbody>
            	<tr v-for="week in month">
            		<td :class="(getDaysSize(today,(getNormalMonth(monthIndex+Number($index))+'-'+day)))>=0?((isActive(getNormalMonth(monthIndex+Number($index)),day)&&day)||(isInRange(getNormalMonth(monthIndex+Number($index)),day))?'day active':'day'):(day?'disable':'')" v-for="day in week" @click="select(getNormalMonth(monthIndex+Number($index)),day)">
            			{{day}}
            			
            		</td>
            	</tr>
            </tbody>
		</table>
		
	</div>
</template>

<script>
export default {
  name: "datePicker",
  props: {
    beginSlot: {
      type: String,
      default: ""
    },
    endSlot: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      monthIndex: 0,
      today: this.getDate(0),
      tableData: {},
      begin: "",
      end: ""
    };
  },
  watch: {
    monthIndex() {
      this.initTable();
    },
    begin(val) {
      this.begin = val;
      this.initTable();
    },
    end(val) {
      this.end = val;
      this.initTable();
    }
  },
  methods: {
    add() {
      if(this.monthIndex < 11) {
				this.monthIndex += 1;
			}
    },
    min() {
      if(this.monthIndex > 0) {
				this.monthIndex -= 1;
			}
    },
    select(month, day) {
      if (day < 10) {
        day = "0" + day;
      }
      var Days = month + "-" + day;
      if (!this.begin || (this.begin && this.end)) {
        this.begin = Days;
        this.end = "";
      } else if (this.begin && !this.end) {
        //反选日期
        if (this.isOpposite(Days, this.begin)) {
          this.end = this.begin;
          this.begin = Days;
        } else {
          this.end = Days;
        }
        var dateArr = this.getDateArr(this.begin, this.end);
        //选中日期
        this.$emit("onDateChange", dateArr, this.begin, this.end);
      }
    },
    // 生成日期组
    getDateArr(startDay, endDay) {
      let startVal = new Date(startDay).getTime();
      let endVal = new Date(endDay).getTime();
      let dayArr = [];
      while (startVal <= endVal) {
        dayArr.push(new Date(startVal).toISOString().split("T")[0]);
        startVal += 24 * 60 * 60 * 1000; // 增加一天
      }
      return dayArr;
    },
    //是否选中
    isActive(month, day) {
      if (!day) return;
      if (day < 10) {
        day = "0" + day;
      }
      var begin = this.begin;
      var end = this.end;
      var s1 = new Date(begin).getTime();
      var s2 = new Date(end).getTime();
      var s = new Date(month + "-" + day).getTime();
      return s == s1 || s == s2 ? true : false;
    },
    //判断是否反转日期
    isOpposite(end, begin) {
      var s1 = new Date(begin).getTime();
      var s2 = new Date(end).getTime();
      return s2 < s1 ? true : false;
    },
    //查看是否是已经选中的日期区间中
    isInRange(month, day) {
      if (!day) return;
      if (day < 10) {
        day = "0" + day;
      }
      var begin = this.begin;
      var end = this.end;
      var s1 = new Date(begin).getTime();
      var s2 = new Date(end).getTime();
      var s = new Date(month + "-" + day).getTime();
      if (s <= s2 && s >= s1) return true;
    },
    /*获取一个月的天数 */
    getCountDays(date) {
      date = date.replace(/-/g, "/");
      date = date + "/01";

      var curDate = new Date(date);
      /* 获取当前月份 */
      var curMonth = curDate.getMonth();
      /*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
      curDate.setMonth(curMonth + 1);
      /* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
      curDate.setDate(0);
      /* 返回当月的天数 */

      return curDate.getDate();
    },
    //获取一个月份的每一天
    getEvryDay(index) {
      var dayArry = [];
      var date = this.getNormalMonth(index);

      var day = this.getCountDays(date);

      for (var k = 1; k <= day; k++) {
        dayArry.push(k);
      }
      return dayArry;
    },
    //生成表格数据结构
    initTable() {
      var array = {};

      for (var i = 0; i < 2; i++) {
        var index = this.monthIndex;
        var days = this.getEvryDay(i + index);
        var daysArray = days;
        var temp = this.getFullfillDateTable(
          daysArray,
          this.getNormalMonth(index + i) + "-01"
        );
        array[i] = temp;
      }
      this.tableData = array;
    },
    //将数据格式化表格日期格式
    getFullfillDateTable(data, date) {
      var data = data;
      var weekday = this.getWeekday(date);
      for (var i = 0; i < weekday; i++) {
        data.unshift("");
      }
      var result = [];
      //补全日期前几天
      for (var i = 0, len = data.length; i < len; i += 7) {
        result.push(data.slice(i, i + 7));
      }
      //补全日期后几天
      var length = result[result.length - 1].length;
      if (length < 7) {
        for (var i = 0; i < 7 - length; i++) {
          result[result.length - 1].push("");
        }
      }
      return result;
    }
  },
  mounted() {
    var that = this;
    that.begin = that.beginSlot || this.getDate(0);
    that.end = that.endSlot || this.getDate(0);
    that.initTable();
    var body = document.getElementsByTagName("body");
    if (!body[0]) {
      return;
    } //判断页面是否html不完整，没有body元素
    //给body添加事件委托，监听input的点击事件
    // body[0].addEventListener("click", function(e) {
    //   if (e.target.className && e.target.className != "day") {
    //     console.log(e.target.className)
    //     that.$emit("onDateChange");
    //   }
    // });
  }
};
</script>



// WEBPACK FOOTER //
// src/common/DatePicker/DatePicker1.vue